<template>
  <div class="ac-card-content">
    <div class="edit-warn-header-container">
      <div class="flex-row">
        <img
          src="@shared/assets/img/general/alert.png"
          class="ac-info"
          alt="Information"
        />
        <div class="ac-header">Edit Plan</div>
      </div>
    </div>
    <div class="edit-warn-card-body-ft-container">
      <div class="ac-body-container">
        <div class="ac-body">
          <div class="edit-warn-info-container">
            <div class="edit-warn-info">{{ selectedPlan.name }} Plan</div>
            <div class="edit-warn-info">
              Members Active: {{ selectedPlan.activeMembers }}
            </div>
          </div>
          <div
            v-if="!isSmacAdmin && selectedPlan.activeMembers > 0"
            class="edit-warn-body-text"
          >
            Once a plan has active members, it can no longer be edited. If you
            would like to edit a plan, please contact your Partner Success
            Manager directly or email
            <a href="mailto:partners@smartac.com">partners@smartac.com</a>.
          </div>
          <div v-else class="edit-warn-body-text">
            Updating plan details will affect active members.
          </div>
        </div>
      </div>
      <div class="edit-warn-ft-container">
        <button type="button" class="secondary-button" @click="close">
          Cancel
        </button>
        <button
          v-if="selectedPlan.activeMembers === 0 || isSmacAdmin"
          type="button"
          class="primary-button"
          @click="submit"
        >
          Continue
        </button>
        <a
          v-else
          href="mailto:partners@smartac.com"
          type="button"
          class="primary-button"
        >
          Email
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import partnerSettingsMixin from '@shared/mixins/partnerSettingsMixin';
import { mapGetters } from 'vuex';

export default {
  name: 'EditPlanWarn',
  mixins: [partnerSettingsMixin],
  props: {
    close: Function,
    submit: Function,
  },
  computed: {
    ...mapGetters([
      'isSmacAdmin',
    ]),
    hasActiveMembers() {
      return this.selectedPlan.activeMembers > 0;
    },
    currentPath() {
      return this.$route.path;
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-warn-info {
  font-size: 18px;
  font-weight: 600;
}

.edit-warn-info-container {
  display: flex;
  width: 652px;
  justify-content: space-between;
}

.edit-warn-header-container {
  padding: 24px 24px 0px 24px;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  .ac-header {
    font-size: 1.25rem;
    font-weight: 600;
    margin-left: 12px;
  }

  .ac-info {
    width: 25px;
    object-fit: contain;
    margin-right: 6px;
  }
}

.edit-warn-body-text-base {
  font-size: 16px;
  color: #7f8290;
  text-align: start;
}

.edit-warn-body-text {
  @extend .edit-warn-body-text-base;
  margin-top: 40px;
   margin-bottom: 10px;
}

.edit-warn-card-body-ft-container {
  margin-top: -14px;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
}

.edit-warn-ft-container {
  display: flex;
  align-items: end;
  gap: 16px;
  justify-content: end !important;
  margin: 0 24px;
  margin-bottom: 12px;

  .secondary-button {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: $WHITE;
    border: solid 4px $NBLUE100;
    border-radius: 8px;
    color: $NBLUE100;
    padding: 12px 18px;
    font-weight: 600;
  }

  .primary-button {
    display: flex;
    flex-direction: column;
    align-items: center;
    border: solid 4px $NBLUE100;
    background-color: $NBLUE100;
    border-radius: 8px;
    color: $WHITE;
    padding: 12px 18px;
    font-weight: 600;
  }
}
</style>
